<template>

  <b-dropdown
    variant="link"
    no-caret
    right
    class="chart-dropdown"
    toggle-class="p-0"
  >
    <template #button-content>
      <feather-icon
        icon="MoreVerticalIcon"
        size="18"
        class="text-body cursor-pointer"
      />
    </template>
    <b-dropdown-item
      v-if="isDraft"
      @click="$emit('publish')"
    >
      <feather-icon
        icon="ShareIcon"
        size="16"
      />
      <span class="itemlabel">{{ $t('Publish') }}</span>

    </b-dropdown-item>
    <b-dropdown-item
      v-if="availableActions.includes('search')&&isPermitted('searchBox')&&searchable"
      @click="$emit('search')"
    >
      <feather-icon
        icon="SearchIcon"
        size="16"
      />
      <span class="itemlabel">{{ $t('Search Box') }}</span>

    </b-dropdown-item>
    <b-dropdown-item
      v-if="availableActions.includes('edit')&&isPermitted('editBox')"
      @click="$emit('edit')"
    >
      <feather-icon
        icon="EditIcon"
        size="14"
      />
      <span class="itemlabel">{{ $t('Edit Box') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="availableActions.includes('download')&&isPermitted('exportBox')"
      :title="$t('Download Box')"
      @click="$emit('download')"
    >
      <feather-icon
        icon="DownloadIcon"
        size="14"
      />
      <span class="itemlabel">{{ $t('Download Box') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="availableActions.includes('clone')&&isPermitted('cloneBox')"
      @click="$emit('clone')"
    >
      <feather-icon
        icon="CopyIcon"
        size="14"
      />
      <span class="itemlabel">{{ $t('Clone Box') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-else-if="availableActions.includes('clone_to_my_dashboard')&&isPermitted('myDashboard')&&!currentlyInMyDashboard"
      @click="$emit('clone_to_my_dashboard')"
    >
      <feather-icon
        icon="StarIcon"
        size="14"
      />
      <span class="itemlabel">{{ $t('Save To My Dashboard') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="availableActions.includes('drill')&&isPermitted('addDrill')"
      @click="$emit('drill')"
    >
      <feather-icon
        icon="ChevronsRightIcon"
        size="14"
      />
      <span
        class="itemlabel"
      >{{ $t('Add Drill') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="(availableActions.includes('delete')&&isPermitted('deleteBox'))||currentlyInMyDashboard"
      @click="$emit('delete')"
    >
      <feather-icon
        icon="TrashIcon"
        size="14"
      />
      <span
        class="itemlabel"
      >{{ $t('Delete Box') }}</span>
    </b-dropdown-item>
  </b-dropdown>

</template>

<script>
import { getUserData, isPermitted } from '@/auth/utils'
import {
  BDropdown, BDropdownItem,
} from 'bootstrap-vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  props: {
    availableActions: {
      type: Array,
      default: () => [],
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    currentlyInMyDashboard: {
      type: Boolean,
      default: false,
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.userData = getUserData()
  },
  methods: {
    isPermitted(code) {
      // skip check if pdf export
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
  },
}
</script>

<style>
.itemlabel{vertical-align:middle;margin-left:8px;}
</style>
